import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { RegexService } from '../../../services/regex.service';
import { checkPasswords } from '../../../utils/custom-validators';

@Component({
    selector: 'app-password-set',
    templateUrl: './password-set.component.html',
    styleUrls: ['./password-set.component.scss'],
})
export class PasswordSetComponent implements OnInit, OnDestroy {
    form: FormGroup;
    resetData = {
        password: '',
        autoId: '',
    };
    notAuthorized = false;
    oldPasswordUsed = false;

    private _subscriptions: Subscription = new Subscription();

    constructor(
        public regexService: RegexService,
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private fb: FormBuilder
    ) {
       
        this.form = this.fb.group(
            {
                password: [
                    '',
                    [
                        Validators.required,
                        this.regexService.validatePasswordField(),
                    ],
                ],
                passwordConfirm: ['', [Validators.required]],
            },
            {
                validators: [checkPasswords()],
            }
        );
    }

    ngOnInit(): void {
        this._subscriptions.add(
            this.form.valueChanges.subscribe(() => this.oldPasswordUsed = false)
        )
        this.resetData.autoId = this.route.snapshot.params.Id;
    }

    ngOnDestroy(): void {
        this._subscriptions.unsubscribe();
    }

    onSubmit() {
        this.resetData.password = this.form.value.password;
        this._subscriptions.add(this.authService.passwordSet(this.resetData).subscribe(
            () => {
                this.router.navigate(['/password', 'confirmation']);
            },
            (error) => {
                if (error.error.code === 'AUTH-0001') {
                    this.oldPasswordUsed = true
                } else {
                    this.notAuthorized = true;
                }
            }
        ));
    }

    get hasErrors() {
        return this.notAuthorized || this.oldPasswordUsed;
    }
}
